// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Y2Cu","right":"styles_right__2l_cx"};